import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Categories14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.88381 1.32321C7.39565 0.835052 6.6042 0.835054 6.11604 1.32321L4.32315 3.1161C3.83499 3.60426 3.83499 4.39571 4.32315 4.88387L6.11604 6.67676C6.6042 7.16492 7.39565 7.16492 7.88381 6.67676L9.6767 4.88387C10.1649 4.39571 10.1649 3.60426 9.6767 3.1161L7.88381 1.32321ZM5.56059 3.99999L6.99992 2.56065L8.43926 3.99999L6.99992 5.43933L5.56059 3.99999Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.25 9.75C0.25 8.09315 1.59315 6.75 3.25 6.75C4.90685 6.75 6.25 8.09315 6.25 9.75C6.25 11.4069 4.90685 12.75 3.25 12.75C1.59315 12.75 0.25 11.4069 0.25 9.75ZM3.25 8.25C2.42157 8.25 1.75 8.92157 1.75 9.75C1.75 10.5784 2.42157 11.25 3.25 11.25C4.07843 11.25 4.75 10.5784 4.75 9.75C4.75 8.92157 4.07843 8.25 3.25 8.25Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.1556 7.13577L13.6556 11.6358C13.9283 12.1266 13.5615 12.75 13 12.75H8C7.43855 12.75 7.07172 12.1266 7.34438 11.6358L9.84438 7.13577C10.1248 6.63102 10.8752 6.63102 11.1556 7.13577ZM11.7254 11.25L10.5 9.04434L9.27464 11.25H11.7254Z'
      fill='currentColor'
    />
  </Svg>
);

Categories14.displayName = 'Categories14';
export default Categories14;
